
import ApiServiceAxios from '../service/ApiServiceAxios';
import MethodService from '../service/MethodService';
import { Buffer } from 'buffer';

let moduleApi = {};
let token = MethodService.getToken();
let UrlApiDkk = window.MyConfig.dkkUrl;

moduleApi.GetListBooking = async (body_param) => {

    const body = body_param;
    console.log(body);
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiDkk + "DkkRegister/GetView?param=" + objJsonB64,
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: token,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
};

moduleApi.getHospital = async (provinceID, tokenTH) => {
    let tokenApi = tokenTH ? tokenTH : token;
    const body = {
        "ApiData": {
            "ORDER_FIELD": "MODIFY_TIME",
            "ORDER_DIRECTION": "DESC",
            "ID": null,
            "IS_ACTIVE": 1,
            "CREATE_TIME_FROM": null,
            "CREATE_TIME_TO": null,
            "MODIFY_TIME_FROM": null,
            "MODIFY_TIME_TO": null,
            "CREATOR": null,
            "MODIFIER": null,
            "GROUP_CODE": null,
            "KEY_WORD": "",
            "IDs": null,
            "PROVINCE_CODE_EXTRACT": provinceID ? provinceID : null
        }
    }
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiDkk + "DkkHospital/Get?param=" + objJsonB64,
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: tokenApi,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
}

moduleApi.getService = async (hospital_id) => {
    const body = {
        "ApiData": {
            "ORDER_FIELD": "MODIFY_TIME",
            "ORDER_DIRECTION": "DESC",
            "ID": null,
            "IS_ACTIVE": 1,
            "CREATE_TIME_FROM": null,
            "CREATE_TIME_TO": null,
            "MODIFY_TIME_FROM": null,
            "MODIFY_TIME_TO": null,
            "CREATOR": null,
            "MODIFIER": null,
            "GROUP_CODE": null,
            "KEY_WORD": "",
            "IDs": null,
            "HOSPITAL_ID": hospital_id
        }
    }
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiDkk + "DkkService/Get?param=" + objJsonB64,
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: token,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
}

moduleApi.getPerson = async (hospital_id) => {
    const body = {
        "ApiData": {
            "ORDER_FIELD": "MODIFY_TIME",
            "ORDER_DIRECTION": "DESC",
            "ID": null,
            "IS_ACTIVE": 1,
            "CREATE_TIME_FROM": null,
            "CREATE_TIME_TO": null,
            "MODIFY_TIME_FROM": null,
            "MODIFY_TIME_TO": null,
            "CREATOR": null,
            "MODIFIER": null,
            "GROUP_CODE": null,
            "KEY_WORD": "",
            "IDs": null,
            "HOSPITAL_ID": hospital_id
        }
    }
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiDkk + "DkkPatientType/GetView?param=" + objJsonB64,
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: token,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
}

moduleApi.getRoom = async (hospital_id, service_code) => {
    const body = {
        "ApiData": {
            "ORDER_FIELD": "MODIFY_TIME",
            "ORDER_DIRECTION": "DESC",
            "ID": null,
            "IS_ACTIVE": 1,
            "CREATE_TIME_FROM": null,
            "CREATE_TIME_TO": null,
            "MODIFY_TIME_FROM": null,
            "MODIFY_TIME_TO": null,
            "CREATOR": null,
            "MODIFIER": null,
            "GROUP_CODE": null,
            "KEY_WORD": "",
            "IDs": null,
            "HOSPITAL_ID": hospital_id,
            "SERVICE_CODE": service_code
        }
    }
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiDkk + "DkkRoom/GetView?param=" + objJsonB64,
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: token,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
}

moduleApi.bookingScheduleMedical = async (bodyData) => {
    let api = {
        method: "POST",
        url: UrlApiDkk + "DkkRegister/CreateSdo",
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: token,
        },
        data: bodyData,
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
}

moduleApi.getPttrs = async (hospital_id, patient_type_id, service_id) => {
    const body = {
        "ApiData": {
            "HOSPITAL_ID": hospital_id ? hospital_id : null,
            "PATIENT_TYPE_ID": patient_type_id ? patient_type_id : null,
            "ROOM_ID": null,
            "SERVICE_ID": service_id ? service_id : null,
            "IS_ACTIVE": 1
        }
    }
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiDkk + "DkkPtrs/GetView?param=" + objJsonB64,
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: token,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
}

export default moduleApi;
